import * as C from "@components";
import css from "./announcement-section.module.scss";
import VadImage from "vadimages-nextjs-image-optimizer";
import * as Api from '@api';

export const AnnouncementSectionKeys = [
    "announcement.badge",
    "announcement.title",
    "announcement.body",
    "announcement.btn",
] as const;

export type AnnouncementSectionProps = {
    pageContent: Api.Content<typeof AnnouncementSectionKeys[number]>;
}

export const AnnouncementSection = ({ pageContent } : AnnouncementSectionProps) =>
{
    return (
        <C.PageSection>
            <div className={css["second-card"]}>
                <div className={css["text"]}>
                    <div className={css["badge-new"]}>{pageContent["announcement.badge"]?.data}</div>
                    <div className={css["title"]}>{pageContent["announcement.title"]?.data}</div>
                    <div className={css["text"]}>{pageContent["announcement.body"]?.data}</div>
                    <C.PageLink data-hidden-on-mobile href="/products/all-in-ones/active-leaf" variant={C.PageLinkVariant.Button}>{pageContent["announcement.btn"]?.data}</C.PageLink>
                </div>
                <div className={css["image"]}>
                    <VadImage src={"/images/announcement/leaf-promo.png"} width={"329"} height={"300"} alt={""} />
                </div>
                <C.PageLink data-hidden-on-desktop href="/products/all-in-ones/active-leaf" variant={C.PageLinkVariant.Button}>{pageContent["announcement.btn"]?.data}</C.PageLink>
                {/*<div className={css["video"]}>*/}
                {/*    <C.FixedRatioBox aspecRatio={600 / 338}>*/}
                {/*        <C.Video allowControls src="/video/xl-series.mp4" sourceType="video/mp4" poster={"/images/announcement-poster.png"} />*/}
                {/*    </C.FixedRatioBox>*/}
                {/*</div>*/}
                {/*<C.VideoControlController />*/}
            </div>
        </C.PageSection>
    );
}

export default AnnouncementSection;